import gql from 'graphql-tag'
import { orderType } from './fragment'

export default gql`
mutation createOrderType($required: OrderTypeInputRequired!, $fields: OrderTypeInput) {
	cashAssist {
		createMutation: createOrderType(required: $required, fields: $fields) {
			...orderType
		}
	}
}
${orderType}`
